var link_viewer_default = {
  "fontElementMap": "xHYt8",
  "link": "_3B7bV",
  "linkInEditor": "VRzBb",
  "linkInViewer": "j2zpi",
  "toolbarUrlContainer": "GdjIG",
  "toolbarUrl": "Z-Y6S",
  "toolbarUrlAnchor": "aZ7lZ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
